import { render, staticRenderFns } from "./MarkdownContent.vue?vue&type=template&id=37a5aab8&scoped=true&"
import script from "./MarkdownContent.vue?vue&type=script&lang=js&"
export * from "./MarkdownContent.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownContent.vue?vue&type=style&index=0&id=37a5aab8&prod&lang=css&"
import style1 from "./MarkdownContent.vue?vue&type=style&index=1&id=37a5aab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5aab8",
  null
  
)

export default component.exports